import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ["spinner", "title", "progressBar", "steps"]
  static values  = { cvId: Number }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "CvGenerationChannel", cv_id: this.cvIdValue },
      { received: (data) => this.handleBroadcast(data) }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  handleBroadcast(data) {
    const progressMap = {
      reading_profile:   15,
      sending_to_gemini: 35,
      converting_to_pdf: 75,
      saving:            90,
      complete:          100,
      failed:            100
    }

    const progress = progressMap[data.step] || 0
    this.progressBarTarget.style.width = `${progress}%`

    this.updateStep(data.step, data.status)

    if (data.status === "done") {
      this.titleTarget.textContent = "CV generated successfully!"
      setTimeout(() => window.location.reload(), 1000)
    }

    if (data.status === "error") {
      this.titleTarget.textContent = data.message || "Generation failed. Please try again."
      this.progressBarTarget.classList.add("bg-danger")
      this.progressBarTarget.classList.remove("bg-primary")
      this.spinnerTarget.classList.remove("animate-spin")
    }
  }

  updateStep(activeStep, status) {
    const steps = this.stepsTarget.querySelectorAll("[data-step]")
    const order = ["reading_profile", "sending_to_gemini", "converting_to_pdf", "saving"]
    const activeIndex = order.indexOf(activeStep)

    steps.forEach((step, i) => {
      const icon = step.querySelector("[data-step-icon]")
      const label = step.querySelector("[data-step-label]")

      if (i < activeIndex) {
        icon.innerHTML = `<svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>`
        icon.className = "w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 bg-success-light text-success-dark"
        label.className = "text-ink-muted line-through"
      } else if (i === activeIndex) {
        icon.innerHTML = `<svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" class="animate-spin"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`
        icon.className = "w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 bg-primary-light text-primary"
        label.className = "text-ink font-semibold"
      }
    })
  }
}